import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { AnnonceContext } from "../context/AnnonceProvider";

const DELAI_OUVERTURE_MS = 1500;

const AnnonceModale = () => {
  const { afficherAnnonce, avantConge, modaleVue, setModaleVue } =
    useContext(AnnonceContext);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!afficherAnnonce || modaleVue) return;
    const timer = setTimeout(() => setShow(true), DELAI_OUVERTURE_MS);
    return () => clearTimeout(timer);
  }, [afficherAnnonce, modaleVue]);

  const handleClose = () => {
    setShow(false);
    setModaleVue(true);
  };

  if (!afficherAnnonce) return null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      backdrop="static"
      keyboard
      aria-labelledby="annonce-modale-title"
      contentClassName="annonceModale"
    >
      <Modal.Header closeButton>
        <Modal.Title id="annonce-modale-title" className="annonceModaleTitle">
          ✨ Petite mise à jour ✨
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="annonceModaleBody">
        {avantConge ? (
          <>
            <p>
              Jusqu'au <strong>3 juillet</strong>, je continue de vous
              accompagner uniquement en consultation 🤍
            </p>
            <p>
              À partir du <strong>3 juillet</strong>, je serai en congé
              maternité et les rendez-vous seront suspendus.
            </p>
          </>
        ) : (
          <p>
            Je suis actuellement en congé maternité, les rendez-vous sont
            suspendus 🤍
          </p>
        )}
        <p>Tout reprendra à l'automne ✨</p>
        <p className="annonceModaleContact">
          Pour toute réservation ou question, vous pouvez me contacter au{" "}
          <a href="tel:+33618010504">06 18 01 05 04</a>.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="light"
          onClick={handleClose}
          className="annonceModaleBtn"
        >
          J'ai compris
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AnnonceModale;
